export default (token: string) => {
  try {
    const end = token.substring(token.length - 4, token.length)
    return `*****${end}`;
  } catch (err) {
    return token;
  }
}
